<template>
  <div>
    <div v-loading="loading">
      <app-marketplace-fields
        v-if="Object.keys(model.fields).length > 0"
        v-model="model.fields"
        :fixed="false"
        :hide-add-button="true"
        @delete="removeField"
        @edit="openEditFieldDialog"
        @add="openAddFieldDialog"
      />

      <ui-alert-message-no-data v-else />

      <ui-button-float
        variant="success"
        @click.prevent="openAddFieldDialog"
      />
    </div>
    <!-- EDIT FIELD DIALOG -->
    <b-modal
      :title="$t('Edit object', { object: $tc('Fields', 1) })"
      :visible="editFieldVisible"
      @hide="closeEditFieldDialog"
    >
      <app-marketplace-field-form v-model="editFieldModel" />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="saveField"
        >
          {{ $t('Save') }}
        </button>
      </template>
    </b-modal>


    <!-- ADD FIELD DIALOG -->
    <b-modal
      :title="$t('Add object', { object: $tc('Fields', 1) })"
      :visible="addFieldVisible"
      @hide="closeAddFieldDialog"
    >
      <app-marketplace-field-form
        v-model="addFieldModel"
        change-key
      />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="addField"
        >
          {{ $t('Add') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import MarketplaceMixins from '../mixins/MarketplaceMixins';
import AppMarketplaceFields from '../components/marketplace-fields/MarketplaceFields.vue';
import AppMarketplaceFieldForm from '../components/marketplace-fields/MarketplaceFieldForm.vue';

export default {
  name: 'AppPageMarketplaceFields',
  components: { AppMarketplaceFields, AppMarketplaceFieldForm },
  mixins: [
    MarketplaceMixins,
  ],
  data() {
    return {
      loading: false,
      addFieldModel: {},
      addFieldVisible: false,
      editFieldModel: {},
      editFieldVisible: false,
    };
  },
  mounted() {
    this.$marketplace_load(this.$marketplace_getRouteId());
  },
  methods: {
    /**
       * Removes a field with specify key.
       * @param {string} key Field Key
       */
    removeField(key) {
      // eslint-disable-next-line no-alert
      if (window.confirm(this.$t('Are you sure?'))) {
        const model = { ...this.model };
        model.fields = {};
        Object.keys(this.model.fields).forEach(e => {
          if (e !== key) {
            model.fields[e] = this.model.fields[e];
          }
        });
        this.model = model;
        this.$marketplace_save().then(() => {
          this.$marketplace_load(this.$marketplace_getRouteId());
        });
      }
    },
    /**
       * Opens a modal dialog with a form for editing a field.
       * @param {string} key Field Key
       */
    openEditFieldDialog(key) {
      this.editFieldModel = { key, ...this.model.fields[key] };
      this.editFieldVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a field.
       */
    closeEditFieldDialog() {
      this.editFieldModel = {};
      this.editFieldVisible = false;
    },
    /**
       * Saving a field.
       * Actually only change a field information in a model.
       */
    saveField() {
      const model = { ...this.model };
      const { key } = this.editFieldModel;
      delete this.editFieldModel.key;
      model.fields[key] = this.editFieldModel;
      this.model = model;
      this.closeEditFieldDialog();
      this.$marketplace_save().then(() => {
        this.$marketplace_load(this.$marketplace_getRouteId());
      });
    },
    /**
       * Opens a modal dialog with a form for editing a field.
       */
    openAddFieldDialog() {
      this.addFieldModel = {
        key: '',
        name: '',
        description: '',
        default: '',
        required: false,
      };
      this.addFieldVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a template.
       */
    closeAddFieldDialog() {
      this.addFieldModel = {};
      this.addFieldVisible = false;
    },
    addField() {
      if (this.addFieldModel.key.length > 0 && this.addFieldModel.name.length > 0) {
        const model = { ...this.model };
        model.fields[this.addFieldModel.key] = {
          name: this.addFieldModel.name,
          description: this.addFieldModel.description,
          default: this.addFieldModel.default,
          required: this.addFieldModel.required,
        };
        this.model = model;
      }
      this.closeAddFieldDialog();
      this.$marketplace_save().then(() => {
        this.$marketplace_load(this.$marketplace_getRouteId());
      });
    },
  },
};
</script>
